export const SafeGlobalThisScript = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: `if (typeof window !== 'undefined' && typeof globalThis === 'undefined') {
        var globalThis = window
      }`,
    }}
  />
);
